import { ErrorText } from '@components/Texts/Texts';
import styled from '@emotion/styled';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import tw, { css } from 'twin.macro';

export const SharingContainer = styled.div`
  ${tw`sm:m-auto sm:text-center`}
  ${tw`p-2 pt-4`}
`;

export const ProfileShareTitle = styled(ErrorText)`
  ${tw`text-light-low`};
`;

export const ProfileShareIconsContainer = styled.div`
  ${tw`mt-2 flex flex-row space-s-2`};
`;

export const FormSuccessShareIcon = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.1);
  ${tw`cursor-pointer w-6 h-6 flex items-center justify-center text-light-high rounded-full`};
`;

const ShareContainer = css`
  outline: none !important;
`;
export const TwitterShareContainer = styled(TwitterShareButton)`
  ${ShareContainer}
`;
export const FacebookShareContainer = styled(FacebookShareButton)`
  ${ShareContainer}
`;
export const WhatsappShareContainer = styled(WhatsappShareButton)`
  ${ShareContainer}
`;
